export function generateBaseUrl(apiUrl, urlVariables) {
    let url = apiUrl;
    if (urlVariables) {
        Object.entries(urlVariables).forEach(([key, value]) => {
            url = url.replace(new RegExp('{\\s*' + key + '\\s*}', 'g'), value);
        });
    }
    return url;
}